'use strict';


app.factory('User', ['$http', '$rootScope', 'Helper', 'Venue', 'env_config', 'S3', '$timeout',
    function ($http, $rootScope, Helper, Venue, env_config, S3, $timeout) {
        var service = {};


        /**
         * search for users
         * 
         * @param  String    search
         * @param  Integer   pagination
         * @param  Function  callback
         */
        service.search = function (search, pagination, callback) {
        		
            $http({
            	url: env_config.api_url + 'users/search',
            	mehod: 'GET',
            	params: {
            		search: search,
            		limit : pagination.limit,
            		offset: pagination.offset
            	}
            })
            .success(function (resp, status){
                callback(resp, status);
            })
            .error(function(resp, status){
                callback(resp, status);
            });
        };


        /**
         * get user details by id or username
         * 
         * @param  Integer|String   param
         * @param  Function         callback
         */
        service.getUserDetails = function(param, callback){
            $http.get(env_config.api_url + 'users/'+param)
                .success(function (resp, status){
                    callback(resp, status);
                })
                .error(function(resp, status){
                    callback(resp, status);
                });
        }


        /**
         * get public user details by id or username
         * 
         * @param  Integer|String   param
         * @param  Function         callback
         */
        service.getPublicUserDetails = function(param, callback){
            $http.get(env_config.api_url + 'users/public/'+param)
                .success(function (resp, status){
                    callback(resp, status);
                })
                .error(function(resp, status){
                    callback(resp, status);
                });
        }

        /**
         * get user credits by id
         * 
         * @param  Function         callback
         */
        service.getCredit = function(callback){
            var user_id = $rootScope.globals.currentUser.id;

            $http.get(env_config.api_url + 'users/'+user_id+'/credits')
                .success(function (resp, status){
                    var credit_obj = {
                            currency : 'SGD',
                            symbol   : 'S$',
                            sum      : 0,
                        };

                    $rootScope.globals.credits = resp.data.credits;

                    // Keep the old logic to prevent bug
                    $rootScope.globals.currentUser.credit = credit_obj;

                    // save credit to storage
                    Helper.updateLocalStorageWithGlobalVariable();

                    // callback function
                    if (typeof callback == 'function'){
                        callback();
                    }
                })
                .error(function(resp, status){
                    console.error('Could not get users credit.');
                });
        }


        /**
         * trigger credit promo
         * @param  String   code
         * @param  Function callback
         */
        service.triggerCreditPromo = function(code, callback){
            $http.put(env_config.api_url + 'credit/promo', { code:code })
                .success(function (resp, status){
                    callback(resp, status);
                })
                .error(function(resp, status){
                    callback(resp, status);
                });
        }


        /**
         * get users image if it exists, else return default image
         * 
         * @param  Object  user
         * @param  String  size  original|small
         * @return String  url to avatar
         */
        service.getUserImage = function(user, size){
            //$rootScope.tempAvatar = Array;
            var size = size || 'original';
            var default_image = 'img/default-avatar.jpg';
            var return_image;

            if( user.ava == null || typeof user.ava == 'undefined' ) return default_image;

            if( size == 'small' ){
                // check if small image exists
                if( user.ava.small != null && typeof user.ava.small != 'undefined' && user.ava.small != '' ){
                    return_image = user.ava.small;
                }
                // fallback to original
                else if( user.ava.original != null && typeof user.ava.original != 'undefined' && user.ava.original != '' ){
                    return_image = user.ava.original;
                }
            }
            else if( size == 'original' ){
                // check if original image exists
                if( user.ava.original != null && typeof user.ava.original != 'undefined' && user.ava.original != '' ){
                    return_image = user.ava.original;
                }
            }

            
            /*S3.getObject(return_image, function(resp, status) {
                setTimeout(function(){
                   $rootScope.tempAvatar[user.id] = resp.data;
                   return resp.data;
                }, 1000);
                
            });*/

            return return_image;
        }


        /**
         * function that checks if the user that is passed
         * as a parameter is checked in in some venue
         * and also checks if that venue is passprotected 
         * and has service type pickupatthebar
         * and spot_type = 1 (venue)
         * 
         * @param   Object  user
         * @return  Boolean
         */
        service.isCheckedIn = function(user){
            
            if( user.thirsty == 0 ) return false;

            if( user.venue.venue_password ) return false;

            if( typeof user.venue.spots_type.id == 'undefined' ){
                if( user.venue.spots_type != 1 ) return false;
            }else{
                if( user.venue.spots_type.id != 1 ) return false;
            }

            if( ! Venue.checkIfServiceTypeExists('pickupathebar', user.venue.service_types) ) return false;

            return true;
        }


        /**
         * get checked in venue id for user
         * 
         * @param   Object  user
         * @return  Integer
         */
        service.getCheckedInVenueId = function(user){
            return user.thirsty;
        }


        /**
         * check if user is logged in
         * 
         * @return Boolean
         */
        service.isLoggedIn = function(){
            
            if( typeof $rootScope.globals == 'undefined' ) return false;

            if( typeof $rootScope.globals.currentUser == 'undefined' ) return false;

            return true;
        }


        return service;
    }]);